import React from 'react';
import { ApiKeys } from '../../../components/apikeys';

const ApiKeysPage: React.FC = () => {
  return (
    <div className="p-6">
      <ApiKeys />
    </div>
  );
};

export default ApiKeysPage;
